import { NgModule } from '@angular/core';

import { AdalService } from './adal.service';
import { AuthenticationGuard } from './authenticated.guard';
import { ConfigService } from './config.service';

@NgModule({
	providers: [AdalService, ConfigService, AuthenticationGuard]
})
export class SharedServicesModule { }
